import authorizationMiddleware from '@/api/middleware/authorization';
import dataExtractMiddleware from '@/api/middleware/dataExtract';
import languageMiddleware from '@/api/middleware/language';
import type { Client as AgentClient } from '@/types/schemas/agent-schema';
import type { Client as CustomerProfileClient } from '@/types/schemas/customer-profile-schema';
import type { Client as ProxyClient } from '@/types/schemas/proxy-schema';
import { OpenAPIClientAxios } from 'openapi-client-axios';

type ApiClientMap = {
  agentApi: AgentClient;
  customerProfileApi: CustomerProfileClient;
  proxyApi: ProxyClient;
};

type ApiClientType = ApiClientMap[keyof ApiClientMap];

export let api!: ApiClientMap;

const configureMiddleware = (client: ApiClientType) => {
  client.interceptors.response.use(
    dataExtractMiddleware
    // createTokenRefreshMiddleware(client)
  );
  client.interceptors.request.use(authorizationMiddleware);
  client.interceptors.request.use(languageMiddleware);
};

export const initClients = async (): Promise<void> => {
  const agentApiDefinition = new OpenAPIClientAxios({
    definition: `/swagger/agent-swagger.json`,
    withServer: {
      url: `${import.meta.env.VITE_APP_PROXY_TARGET}/agent`,
    },
  });
  const agentApi = await agentApiDefinition.init<AgentClient>();
  configureMiddleware(agentApi);

  const customerProfileApiDefinition = new OpenAPIClientAxios({
    definition: `/swagger/customer-profile-swagger.json`,
    withServer: {
      url: `${import.meta.env.VITE_APP_PROXY_TARGET}/customer-profile`,
    },
  });
  const customerProfileApi =
    await customerProfileApiDefinition.init<CustomerProfileClient>();
  configureMiddleware(customerProfileApi);

  const proxyApiDefinition = new OpenAPIClientAxios({
    definition: `/swagger/proxy-swagger.json`,
    withServer: {
      url: `${import.meta.env.VITE_APP_PROXY_TARGET}`,
    },
  });
  const proxyApi = await proxyApiDefinition.init<ProxyClient>();
  configureMiddleware(proxyApi);

  api = {
    agentApi,
    customerProfileApi,
    proxyApi,
  };
};
